import React, { useRef } from 'react';
import { Col, Container, Form, Row } from 'react-bootstrap';
import emailjs from 'emailjs-com';


const Contact = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_b35isar', 'template_6uijcvd', form.current, 'user_qHkSpCYedUqoo7jI8Uura')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
    };
    return (
        <Container className="py-5" id="contact">
            <Row>
                <Col sm={12} md={4}>
                    <h3>Contact</h3>
                    <p>I am inspired by creating great work with people who are as passionate as I am about building something awesome.</p>
                </Col>
                <Col sm={12} md={8}>
                    <Form ref={form} onSubmit={sendEmail}>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>Name </Form.Label>
                            <Form.Control type="text" name="user_name" placeholder="Enter your name" />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>Email </Form.Label>
                            <Form.Control type="email" name="user_email" placeholder="Enter your email" />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                            <Form.Label>Message</Form.Label>
                            <Form.Control as="textarea" rows={3} name="message" placeholder="Message " />
                        </Form.Group>
                        <Form.Control type="submit" value="Send" className="btn btn-primary" />


                    </Form>

                </Col>
            </Row>



        </Container>
    );
}

export default Contact;